import React, { Component } from 'react';
import SweetAlert from 'sweetalert-react';
import {Redirect} from "react-router-dom";
import 'sweetalert/dist/sweetalert.css';

class AlertUpgrade extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            redirect: false
        };

        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
        this.redirect = this.redirect.bind(this);
    }

    open(){
        this.setState({show:true});
    };

    close(){
        this.setState({show:false});
    };

    redirect(){
        this.setState({ show: false });
        this.setState({ redirect: true });
    };

    render() {
        if(this.state.redirect){
            return (<Redirect push to='/settings/suscription'/>)
        }
        return(<SweetAlert
            show={this.state.show}
            title="Actualiza tu plan"
            text='Para poder disfrutar de esta característica debes actualizar tu plan'
            type='warning'
            showCancelButton={true}
            confirmButtonText="Actualizar Plan"
            cancelButtonText="Cancelar"
            confirmButtonColor='#e44745'
            onConfirm={this.redirect}
            onCancel={this.close}
        />)
    }
}
export default AlertUpgrade;



// WEBPACK FOOTER //
// ./src/components/extras/AlertUpgrade.js